import React from "react";

import PropTypes from "prop-types";

type Props<T> = {
  heading?: React.ReactNode;
  items: Array<T>;
  cell: (arg0: T, arg1: number) => React.ReactNode;
  cellClasses?: string;
  paddingCells?: number;
  className?: string;
};
export function ContentRow<T>({ heading, items, cell, cellClasses, paddingCells: paddingAmount, ...rest }: Props<T>) {
  const cellAttrs = cellClasses
    ? {
        className: cellClasses,
      }
    : {};
  const columns = items.map((item, index) => (
    <td key={index} {...cellAttrs}>
      {cell && item ? cell(item, index) : "\u00a0"}
    </td>
  ));
  let paddingCells = null;

  if (paddingAmount && paddingAmount > items.length) {
    const blankCells = paddingAmount - items.length;
    paddingCells = Array(blankCells)
      .fill()
      .map((_, i) => <td key={`paddingCell${i}`}>&nbsp;</td>);
  }

  return (
    <tr {...rest}>
      <th>{heading || "\u00a0"}</th>
      {columns}
      {paddingCells}
    </tr>
  );
}
ContentRow.propTypes = {
  items: PropTypes.array.isRequired,
  cell: PropTypes.func,
  heading: PropTypes.any,
};
